/*
 * Leuchtvolley: Warenkorb-Drawer (Basis Dawn 15.5 cart-drawer.js).
 *
 * - renderContents(parsed) oeffnet den Drawer (Dawn-Verhalten, fuer „In den Warenkorb").
 * - renderSilently(parsed) rendert OHNE zu oeffnen (fuer den Protection-Abgleich beim Seitenaufruf).
 * - Beide ersetzen immer den kompletten Inhalt von .drawer__inner, is-empty folgt dem Inhalt.
 * - Auf der Warenkorbseite oeffnet das Warenkorb-Icon den Drawer nicht (die Seite IST der Warenkorb).
 */
class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    // Delegiert: das Overlay darf beim Neurendern ersetzt werden, der Klick schliesst trotzdem
    this.addEventListener('click', (evt) => {
      if (evt.target && evt.target.id === 'CartDrawer-Overlay') this.close();
    });
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink || cartLink.dataset.lvDrawerBound) return;
    if (document.querySelector('cart-items[data-section-id]')) return;
    cartLink.dataset.lvDrawerBound = '1';

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    // Immer den AKTUELLEN Drawer oeffnen (der Theme-Editor ersetzt die Section beim Bearbeiten)
    const openCurrent = () => (document.querySelector('cart-drawer') || this).open(cartLink);
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      openCurrent();
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code && event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        openCurrent();
      }
    });
  }

  open(triggeredBy) {
    if (this.classList.contains('active')) return;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const empty = this.querySelector('.drawer__inner-empty');
        const containerToTrapFocusOn = empty || document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');

    // cart-drawer-items is a CartItems subclass that extends createViewEventElement.
    // Its `view-event-trigger="manual"` skips auto-dispatch on connect; we fire
    // it here when the drawer opens, with `context: 'dialog'` from the payload attribute.
    const items = this.querySelector('cart-drawer-items');
    if (items && typeof items.dispatchViewEvent === 'function') items.dispatchViewEvent();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  applySections(parsedState) {
    if (!parsedState || !parsedState.sections) return false;
    this.productId = parsedState.id;
    const sections = parsedState.sections;
    let done = false;

    if (sections['cart-drawer']) {
      const source = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html').querySelector('.drawer__inner');
      const target = this.querySelector('.drawer__inner');
      if (source && target) {
        target.innerHTML = source.innerHTML;
        done = true;
      }
    }

    if (sections['cart-icon-bubble']) {
      const bubble = document.getElementById('cart-icon-bubble');
      const source = new DOMParser()
        .parseFromString(sections['cart-icon-bubble'], 'text/html')
        .querySelector('.shopify-section');
      if (bubble && source) bubble.innerHTML = source.innerHTML;
    }

    this.classList.toggle('is-empty', !!this.querySelector('.drawer__inner-empty'));
    return done;
  }

  renderContents(parsedState) {
    this.applySections(parsedState);
    setTimeout(() => this.open());
  }

  renderSilently(parsedState) {
    return this.applySections(parsedState);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const node = new DOMParser().parseFromString(html || '', 'text/html').querySelector(selector);
    return node ? node.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  /* Drawer + Zaehler, auf der Warenkorbseite zusaetzlich die Seite. */
  getSectionsToRender() {
    const list = [{ id: 'CartDrawer', section: 'cart-drawer' }];
    if (document.getElementById('cart-icon-bubble')) list.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble' });
    const page = document.querySelector('cart-items[data-section-id]');
    if (page) list.push({ id: 'page', section: page.dataset.sectionId });
    return list;
  }
}

if (!customElements.get('cart-drawer-items')) customElements.define('cart-drawer-items', CartDrawerItems);
